/**
 * Slim wrapper on Node.contains() that provides a bit of nicety.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
 */

export const contains = (parentNode: Element | null, searchNode: Element | null): boolean => {
    if (!parentNode || !searchNode) {
        return false;
    } else if (parentNode === searchNode) {
        return true;
    } else {
        return parentNode.contains(searchNode);
    }
};
